export default __webpack_public_path__ + "static/media/BH.69ef47fa.ico";